import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
  Update,
} from "@reduxjs/toolkit";
import { RootState } from ".";
import { Fibonacci, FiboType, Label, LabelOption } from "../../types";
import { loadAction } from "./actions";

// Exceptions to the rule "no icons + text!"
export const iconIdAllowedWithText = (id: string | undefined) => {
  switch (id) {
    case undefined:
    case "":
    case "arrowUp":
    case "arrowDown":
      return true;
    default:
      return false;
  }
};

export const defaultLabel = () => ({
  leftIconId: "",
  leftText: "",
  centerText: "",
  rightText: "",
  rightIconId: "",
  centerIconId: "",
  labelType: LabelOption.UNDEFINED,
});

export const fiboAdapter = createEntityAdapter<Fibonacci>();
export const fiboSelectors = fiboAdapter.getSelectors<RootState>(
  (state) => state.document.fibonaccis
);
const fibo = createSlice({
  name: "fibo",
  initialState: fiboAdapter.getInitialState(),
  reducers: {
    fiboAdded: (state, action: PayloadAction<Fibonacci>) => {
      fiboAdapter.addOne(state, action.payload);
    },
    fiboDeleted: fiboAdapter.removeOne,
    fiboUpdated: (state, action: PayloadAction<Update<Fibonacci>>) => {
      let { changes, id } = action.payload;

      if (changes.type === FiboType.Quad) {
        changes.label = [defaultLabel(), defaultLabel()];
      } else if (changes.type === FiboType.Dual) {
        changes.label = [defaultLabel()];
      }

      fiboAdapter.updateOne(state, { id, changes });
    },
    labelUpdated: (
      state,
      action: PayloadAction<{
        id: string;
        labelIndex: number;
        label: Partial<Label>;
      }>
    ) => {
      const { id, labelIndex, label } = action.payload;
      const fibo = state.entities[id];

      if (!fibo) return state;

      // No text + icons
      /*if (label.leftText?.length || label.rightText?.length) {
        const currentLabel = labelPosition
          ? (fibo.label as FourWayLabel)[labelPosition]
          : (fibo.label as Label);

        if (!iconIdAllowedWithText(currentLabel.leftIconId))
          label.leftIconId = defaultLabel().leftIconId;
        if (!iconIdAllowedWithText(currentLabel.rightIconId))
          label.rightIconId = defaultLabel().rightIconId;
      } else if (
        !iconIdAllowedWithText(label.leftIconId) ||
        !iconIdAllowedWithText(label.rightIconId)
      ) {
        const currentLabel = labelPosition
          ? (fibo.label as FourWayLabel)[labelPosition]
          : (fibo.label as Label);

        if (currentLabel.leftText !== "") label.leftText = "";
        if (currentLabel.rightText !== "") label.rightText = "";
      }*/

      fiboAdapter.updateOne(state, {
        id,
        changes: {
          label: {
            ...fibo.label,
            [labelIndex]: {
              ...fibo.label[labelIndex],
              ...label,
            },
          },
        },
      });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadAction, (state, action) => ({
      ...state,
      ...action.payload.fibonaccis,
    }));
  },
});

export default fibo;
